import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import LeadershipRoleListLayer from "../components/LeadershipRoleListLayer";

const LeadershipRoleListPage = () => {
    return (
        <MasterLayout>
            <LeadershipRoleListLayer />
        </MasterLayout>
    );
};

export default LeadershipRoleListPage;
